"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Upvote = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 489 500"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M4.146 270.671l-1.423 1.895c-7.174 11.012.592 26.272 14.347 26.272l115.718-.02.012 184.127c0 9.42 7.628 17.055 17.037 17.055h188.676l2.312-.156c8.316-1.129 14.725-8.264 14.725-16.899l-.005-184.127 115.854.02c14.565 0 22.414-17.108 12.924-28.167L257.16 5.942c-6.799-7.923-19.05-7.923-25.848 0L4.146 270.672zM244.36 46l192.336 219.177-96.933.02-2.34.154c-8.415 1.117-14.901 8.178-14.901 16.721l-.005 182.167H166.064l.012-182.167-.157-2.29c-1.142-8.236-8.355-14.585-17.083-14.585L52 265.177 244.36 46z"
}));

var _default = Upvote;
exports.default = _default;